import React from 'react';
import LinkButton from '@shared/components/LinkButton';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';

/**
 * @typedef {object} ObservationReportDisplayObservationReportDocument
 * @property {string} [fileName]
 */

/**
 * @typedef {object} ObservationReportDisplayObservationReport
 * @property {string} [observedUserName]
 * @property {ObservationReportDisplayObservationReportDocument} [document]
 */

/**
 * @typedef {object} ObservationReportDisplayProps
 * @property {ObservationReportDisplayObservationReport} [observationReport]
 * @property {() => void} onDownload
 * @property {boolean} [loading]
 */

/**
 * @param {ObservationReportDisplayProps} props
 */
export const ObservationReportDisplay = props => {
  const { observationReport, onDownload, loading } = props;

  const handleDownload = () => {
    onDownload();
  };

  return (
    <div className='observation-report-display'>
      <SkeletonWrapper show={loading} inheritParentSize>
        <span className='field-value bold'>{observationReport.observedUserName}: </span>
        <LinkButton className='link-button' onClick={handleDownload}>
          {observationReport.document.fileName}
        </LinkButton>
      </SkeletonWrapper>
    </div>
  );
};
